import React from "react";
import styles from '../TemplatesPreview.module.scss';

const ElementEmail = ({ value }) => {
  return (
    <div style={{display: 'flex'}}>
      <div className={styles.groupName}>E-mail:&nbsp;</div>
      <div className={styles.groupCOnteiner}>
        <a href={`mailto:${value}`} target="_blank" rel="noopener noreferrer" className={styles.groupValue}>{value}</a>
      </div>
    </div>
  )
}

export default ElementEmail;